import { merge } from 'lodash'

export default function arrowGenerator(color) {
  return {
    '&[x-placement*="bottom"] $arrow': {
      '&::before': {
        borderColor: `transparent transparent ${color} transparent`,
        borderWidth: '0 1em 1em 1em',
      },
      height: '1em',
      left: 0,
      top: 0,
      transform: 'translateY(-100%)',
      width: '3em',
    },
    '&[x-placement*="left"] $arrow': {
      '&::before': {
        borderColor: `transparent transparent transparent ${color}`,
        borderWidth: '1em 0 1em 1em',
      },
      height: '3em',
      right: 0,
      transform: 'translateX(100%)',
      width: '1em',
    },
    '&[x-placement*="right"] $arrow': {
      '&::before': {
        borderColor: `transparent ${color} transparent transparent`,
        borderWidth: '1em 1em 1em 0',
      },
      height: '3em',
      left: 0,
      transform: 'translateX(-100%)',
      width: '1em',
    },
    '&[x-placement*="top"] $arrow': {
      '&::before': {
        borderColor: `${color} transparent transparent transparent`,
        borderWidth: '1em 1em 0 1em',
      },
      bottom: 0,
      height: '1em',
      left: 0,
      transform: 'translateY(100%)',
      width: '3em',
    },
    opacity: 1,
  }
}

export function rotatedArrowGenerator(color, offsetPopper = false) {
  let styles = {
    '&[x-placement*="bottom"]': {
      '& $arrow': {
        left: 0,
        top: 0,
        transform: 'translateY(-50%) rotate(45deg)',
      },
    },
    '&[x-placement*="left"]': {
      '& $arrow': {
        right: 0,
        transform: 'translateX(50%) rotate(45deg)',
      },
    },
    '&[x-placement*="right"]': {
      '& $arrow': {
        left: 0,
        transform: 'translateX(-50%) rotate(45deg)',
      },
    },
    '&[x-placement*="top"]': {
      '& $arrow': {
        bottom: 0,
        transform: 'translateY(50%) rotate(45deg)',
      },
    },
  }

  if (offsetPopper) {
    styles = merge({}, styles, {
      '&[x-placement*="bottom"]': {
        marginTop: '14px',
      },
      '&[x-placement*="left"]': {
        marginRight: '14px',
      },
      '&[x-placement*="right"]': {
        marginLeft: '14px',
      },
      '&[x-placement*="top"]': {
        marginBottom: '14px',
      },
    })
  }

  return styles
}
